
// Stub to check for features
export const FEATURES = {
  SUBSCRIPTIONS: 'subscriptions',
}


export function featureActive(featureName: string, user: any): boolean {
  let active = false;
  switch (featureName) {
    case FEATURES.SUBSCRIPTIONS:
      active = Boolean(process.env.NEXT_PUBLIC_FEATURES_SUBSCRIPTIONS)
      break;

    default:
      break;
  }
  return active;
}

export default featureActive